import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/react-hooks';
import { useParams } from 'react-router-dom';
import classnames from 'classnames';
import { GroupSummaryQuery } from 'services';
import { pluralize } from 'helpers/string';

import Icon from 'assets/icons';
import styles from './GroupSummary.module.scss';

interface GroupSummaryData {
  groupById: {
    id: string;
    name: string;
    activityFeed: {
      pageInfo: {
        total: number;
      };
    };
    pinnedNodes: {
      pageInfo: {
        total: number;
      };
    };
  };
}

interface GroupSummaryProps {
  showPinned?: boolean;
  togglePinned?: () => void;
}

export const GroupSummary: React.FC<GroupSummaryProps> = ({ showPinned, togglePinned }) => {
  const { t } = useTranslation();
  const { groupId } = useParams();
  const { error, data } = useQuery<GroupSummaryData>(GroupSummaryQuery, {
    variables: { groupId },
    fetchPolicy: 'cache-and-network',
  });

  if (data === undefined) return <GroupSummaryLoader />;

  if (error) return <GroupSummaryLoader />;

  return (
    <div className={classnames(styles.container)}>
      <span>
        <strong>{data.groupById.activityFeed.pageInfo.total.toLocaleString()}</strong>{' '}
        {pluralize(
          data.groupById.activityFeed.pageInfo.total,
          t('profile-screen.profile-hero.document')
        )}
      </span>
      <span
        className={classNames(styles.groupSummaryPin, { [styles.active]: showPinned })}
        onClick={() => {
          togglePinned && togglePinned();
        }}
      >
        <Icon.Pin className={styles.iconPin} /> <strong>{data.groupById.pinnedNodes.pageInfo.total.toLocaleString()}</strong>&nbsp;pinned
      </span>
    </div>
  );
};

export const GroupSummaryLoader = () => {
  return <div className={styles.groupSummaryLoader} />;
};
